import { render, staticRenderFns } from "./SoftwareLicenseText.vue?vue&type=template&id=5bf37324&scoped=true&"
import script from "./SoftwareLicenseText.vue?vue&type=script&lang=js&"
export * from "./SoftwareLicenseText.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLicenseText.vue?vue&type=style&index=0&id=5bf37324&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf37324",
  null
  
)

export default component.exports